import { ReactNode } from 'react'
import { motion } from 'framer-motion'
import BottomNav from './BottomNav'
import Header from './Header'

interface LayoutProps {
  children: ReactNode
}

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <Header />
      
      {/* Main Content */}
      <main className="pb-24 pt-16">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.3 }}
          className="max-w-md mx-auto px-4"
        >
          {children}
        </motion.div>
      </main>
      
      {/* Bottom Navigation */}
      <BottomNav />
    </div>
  )
}